import { PutTripDatesType } from '@orbit/api-types'
import { usePut } from '@hooks/useApi'
import { queryKeys } from '@lib/queryKeys'
import { useQueryClient } from '@tanstack/react-query'
import { Trip } from '@types'

/**
 * `PUT /trips/:id/tripDates` — the pre-destinations way to date and size a
 * trip. The edit-destinations flow falls back to it for a trip that never had
 * destinations (their PUT needs at least one row).
 */
export const useUpdateTripDates = (tripId: string) => {
	const queryClient = useQueryClient()

	return usePut<PutTripDatesType, Trip>(`/trips/${tripId}/tripDates`, {
		onSuccess: updatedTrip => {
			queryClient.invalidateQueries({ queryKey: queryKeys.trip(tripId) })
			queryClient.invalidateQueries({ queryKey: queryKeys.trips() })
			queryClient.invalidateQueries({ queryKey: queryKeys.events(tripId) })
			queryClient.setQueryData(queryKeys.trip(tripId), updatedTrip)
		},
	})
}
